var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../classes/runtime/Runtime';
let AvailableTooltip = class AvailableTooltip extends React.PureComponent {
    render() {
        const { children } = this.props;
        if (!runtime.availablePackages.Lazy)
            return children;
        const Tooltip = runtime.availablePackages.Lazy.components.Tooltip;
        return React.createElement(Tooltip, { ...this.props });
    }
};
AvailableTooltip = __decorate([
    observer
], AvailableTooltip);
export { AvailableTooltip };
